/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
// import { Logger } from "cms/utils/log/logger";

const useGetCurrentWebsite = () => {
    
    // Logger.info('Get Current Website:')
    // Logger.flush()
    const currentWebsite = useSelector((state) => {
        return state.website.current;
    });

    return { currentWebsite };
    
};

useGetCurrentWebsite.displayName = "useGetCurrentWebsite";
export { useGetCurrentWebsite };
